<template>
    <transition name="layout-fade">
        <loader v-if="loading"/>
        <v-layout wrap column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Статистика заказанных продуктов</v-toolbar-title>
                <v-spacer/>
                <v-btn icon :loading="loading" :disabled="loading" @click="closeLayout">
                    <v-icon>close</v-icon>
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>

            <v-form class="form-add">
                <v-card>
                    <v-card-title>
                        <v-row align="center">
                            <v-col>
                                <download-excel
                                    class="v-btn v-btn--contained theme--light v-size--default info excel--export"
                                    :data="products"
                                    :fields="excel_headers"
                                    worksheet="Products statistics"
                                    name="statistics.xls">
                                    Экспортировать в Excel
                                </download-excel>

                                <br>

                                <v-select
                                    :items="items"
                                    v-model="date"
                                    label="Укажите дату"
                                ></v-select>
                            </v-col>

                            <v-col class="d-flex">
                                <v-spacer></v-spacer>
                            </v-col>

                            <v-col class="d-flex">
                                <v-text-field
                                    v-model="search"
                                    append-icon="mdi-magnify"
                                    label="Поиск"
                                    single-line
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-title>

                    <v-data-table
                        :headers="headers"
                        :items="products"
                        :sort-by="['orders_count']"
                        :sort-desc="[true]"
                        :items-per-page="25"
                        :search="search"
                        class="elevation-1"
                    ></v-data-table>
                </v-card>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import Statistic from '../../../api/statistic'
    import Loader from '../../../components/Loader/Layout'
    import Sex from './Components/Customer/Sex'
    import Device from './Components/Customer/Device'

    export default {
        name: 'statisticProducts',
        components: {
            Loader,
            Sex,
            Device
        },
        data: () => ({
            loading: false,
            date: 'all',
            items: [
                {
                    text: 'День',
                    value: 'day'
                },
                {
                    text: 'Неделя',
                    value: 'week'
                },
                {
                    text: 'Месяц',
                    value: 'month'
                },
                {
                    text: 'Последний год',
                    value: 'year'
                },
                {
                    text: 'Все время',
                    value: 'all'
                }],
            search: '',
            excel_headers: {
                'Наименование': 'name',
                'Категория': 'category.name',
                'Общее количество заказов': 'orders_count',
                'Количество заказов через Telegram': 'orders_telegram_count',
                'Количество заказов через Сайт': 'orders_site_count',
                'Количество заказов через Приложения': 'orders_app_count',
            },
            headers: [
                // { text: 'ID', value: 'id' },
                {
                    text: 'Наименование',
                    value: 'name'
                },
                {
                    text: 'Категория',
                    value: 'category.name'
                },
                {
                    text: 'Общее количество заказов',
                    value: 'orders_count'
                },
                {
                    text: 'Количество заказов через Telegram',
                    value: 'orders_telegram_count'
                },
                {
                    text: 'Количество заказов через Сайт',
                    value: 'orders_site_count'
                },
                {
                    text: 'Количество заказов через Приложения',
                    value: 'orders_app_count'
                },
            ],
            products: [],
        }),

        watch: {
            date (val) {
                this.getStatistics()
            }
        },

        mounted () {
            this.getStatistics()
        },

        created () {
            this.setHeaderTitle('Продукты')
        },

        methods: {
            closeLayout () {
                this.$router.push({ name: 'headBlankIndex' })
            },

            getStatistics () {
                this.loading = true

                Statistic
                    .getProductsStat(this.date)
                    .then(response => this.products = response.data.data)
                    .catch(error => new Error(error))
                    .finally(() => this.loading = false)
            },
        }
    }
</script>

<style lang="scss">
    .excel--export {
        cursor: pointer;
    }
    
    .v-select {
        .v-label {
            display: none;
        }

        .v-input__slot {
            margin-bottom: 0;
        }

        &.v-text-field--is-booted {
            .v-text-field__details {
                display: none;
            }
        }
    }
</style>
